import axios from '../../axios'

/*
 * 用户管理模块
 */

// 保存
export const save = (data) => {
    return axios({
        url: '/content/save',
        method: 'post',
        data
    })
}
// 删除
export const batchDelete = (data) => {
    return axios({
        url: '/content/delete',
        method: 'post',
        data
    })
}
// 分页查询
export const findPage = (data) => {
    return axios({
        url: '/content/list',
        method: 'post',
        data
    })
}
// 分页查询
export const detailView = (data) => {
    return axios({
        url: '/content/detail',
        method: 'post',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/modules/cms/content.js